/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

// <a href='https://www.freepik.com/vectors/technology'>Technology vector created by vectorjuice - www.freepik.com</a>
import React, { useContext, useEffect } from 'react';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// local imports
import ErrorFixingImg from '../../assets/ErrorFixing.png';

const ErrorFallback = props => {

    // contexts
    const { fontFamily, theme } = useContext(ThemeContext);

    const addErrorReport = () => {
        props.history.push({
            pathname: "/errorReport",
            state: {
                errorId: props.location.search.substring(4)
            }
        });
    }

    return (
        <div className="row p-5" style={{ fontFamily: fontFamily.primary }}>
            <div className="col-md-6 col-12 m-auto" style={{ fontWeight: "600" }}>
                <div>
                    <h2>Something went wrong</h2>
                    Please try again after sometime, if problem still occurs please contact us by clicking below button
                    <button id="report-error-btn" className="btn mt-1" style={theme.button} onClick={addErrorReport}>Report error</button>
                </div>
            </div>
            <img className="col-md-6 col-12 m-auto" src={ErrorFixingImg} height="auto" width="80%" />
        </div>
    )

}

export default ErrorFallback;